import type { HometownNewsApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';

import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchEmptyResults } from '../SearchEmptyResults';

export function HometownNewsList({ items }: { items: HometownNewsApiDto[] }) {
  if (items.length < 1) return <SearchEmptyResults />;

  return (
    <ul className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100 mobile-tablet:pb-0">
      {items.map((item) => (
        <li key={item.hometownNewsIdIdx ?? item.hometownNewsId}>
          <SearchContentsCard
            imageSrc={item.thumbnail}
            title={item.hometownNewsName}
            content={item.summary}
            daysAgo={formatDateLabel(item.publishedAt)}
            link={ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
              idIdx: buildDetailSlug(
                item.hometownNewsIdIdx ?? '',
                item.hometownNewsName,
              ),
            })}
          />
        </li>
      ))}
    </ul>
  );
}
